import {AfterViewInit, Component, ElementRef, Inject, ViewChild} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material';
import {Document} from '../../model/Entities/Document';

@Component({
    selector: 'document-link-dialog',
    templateUrl: './document-link.dialog.component.html',
    styleUrls: ['./document-link.dialog.component.scss']
})
export class DocumentLinkDialogComponent implements AfterViewInit {

    document: Document;

    constructor(public dialog: MatDialogRef<DocumentLinkDialogComponent>,
                @Inject(MAT_DIALOG_DATA) public data: any) {

        this.document = data.document;
    }

    ngAfterViewInit(): void {
    }

    documentSelected(document: any) {
        this.dialog.close(document);
    }
}



// WEBPACK FOOTER //
// /app/src/DocumentsModule/DocumentLinkDialogComponent/document-link.dialog.component.ts